import { render, staticRenderFns } from "./ManualAppendButton.vue?vue&type=template&id=a4b80064&scoped=true"
import script from "./ManualAppendButton.vue?vue&type=script&lang=js"
export * from "./ManualAppendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b80064",
  null
  
)

export default component.exports